define('app-Search/modules/specialInterest/viewmodel',["util"], function (util) {
    return {
        target: $("#searchTab6"),
        run: function (settings) {
            var compiledSearch = "";
            var allSpecialInterests = [];
            var appTags = '{"type":"ht","value":"242ebbab-8948-4f02-98bc-df84970858dd","description":"Special interests"}';

            function compileSpecialInterestSearch() {
                var searchQuery = [];

                var numberPassengers = $("#specialInterestPassengers").val();
                if (numberPassengers) searchQuery.push(decodeURIComponent(numberPassengers));

                var hostValue = $("#hostsSearchContentSelect").val();
                if (hostValue && hostValue.length > 0) searchQuery.push(decodeURIComponent(hostValue));

                var searchQueryValue = $("#specialInterestSearchContentSelect").val();

                if (searchQueryValue > "") {
                    searchQuery.push(decodeURIComponent(searchQueryValue));
                } else {
                    searchQuery.push(appTags);
                }

                var dates = $("#siDateField").val();
                var urlEncodedDates = availableDatesDictionary[dates];
                if (urlEncodedDates) searchQuery.push(urlEncodedDates);

                return searchQuery;
            }

            function getSpecialInterestDepartures() {
                if (window.location.pathname.toLowerCase() === "/search" && compiledSearch == "") {
                    var hashData = $(location).attr('hash');

                    if (hashData != "") {
                        var startAt = hashData.indexOf('[');

                        if (startAt >= 0) {
                            var endAt = hashData.lastIndexOf(']');
                            var searchTagsRaw = hashData.substring(startAt, endAt + 1);
                            var searchTags = decodeURIComponent(searchTagsRaw);

                            if (searchTags != "") {
                                compiledSearch = JSON.stringify(JSON.parse(searchTags));
                            }
                        }
                    }
                } else {
                    compiledSearch = compileSpecialInterestSearch().toString();
                }

                $('#specialInterestSearchContentSelect option').remove();

                $.ajax({
                    url: settings.indexUrl,
                    type: "POST",
                    success: function (data) {
                        var specIntData = resources_getObjects(data, 'description', 'Special Interest');

                        specIntData[0].styles.forEach(function (obj) {
                            var stringObj = new Object();
                            stringObj.type = obj.type;
                            stringObj.value = obj.value;
                            stringObj.description = obj.description;

                            allSpecialInterests.push(JSON.stringify(stringObj));

                            var selected = (compiledSearch.indexOf(obj.value) >= 0) ? true : false;
                            var optionValue = encodeURIComponent(JSON.stringify(stringObj));
                            var option = $('<option>').val(optionValue).html("|(" + obj.count + ')|' + obj.description).prop("selected", selected);

                            $('#specialInterestSearchContentSelect').append(option);
                        });

                        //replace the codes around the number of matches so they come thru as spans
                        $("#searchControl").find('#specialInterestSearchContentSelect.options > li > label').html(function (index, html) {
                            html = html.replace("|(", "<span>");
                            html = html.replace(")|", "</span>");

                            return html;
                        });

                        //then delete the numbers from the original option list because they're ugly
                        $('#specialInterestSearchContentSelect > option').html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // and delete the match numbers the caption container - eq(0) gets the correct element of the three matches
                        $('#specialInterestSearchContent .CaptionCont').eq(0).html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // sumoselect is now loaded by app-formElements/main.js but the AJAX hasn't run to populate the list yet, so reload it
                        // doing this here as reloading prior to the replacements broke the functionality even though it appears fine when used elsewhere
                        $('#specialInterestSearchContentSelect')[0].sumo.reload();
                    }
                });

                $('#hostsSearchContentSelect option').remove();

                $.ajax({
                    url: settings.getHostsUrl,
                    type: "POST",
                    success: function (data) {
                        data.forEach(function (obj) {
                            var stringObj = new Object();
                            stringObj.type = "ho";
                            stringObj.value = obj.sitecoreId;
                            stringObj.description = obj.name;

                            var optionValue = encodeURIComponent(JSON.stringify(stringObj));
                            var selected = (compiledSearch.indexOf(obj.sitecoreId) >= 0) ? true : false;
                            var option = $('<option>').val(optionValue).html("|(" + obj.count + ')|' + obj.name).prop("selected", selected);

                            $('#hostsSearchContentSelect').append(option);
                        });

                        //replace the codes around the number of matches so they come thru as spans
                        $("#hostsSearchContentSelect").find("option > li > label").html(function (index, html) {
                            html = html.replace("|(", "<span>");
                            html = html.replace(")|", "</span>");

                            return html;
                        });

                        //then delete the numbers from the original option list because they're ugly
                        $('#hostsSearchContentSelect > option').html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // and delete the match numbers the caption container - eq(0) gets the correct element of the three matches
                        $('#hostsSearchContentSelect .CaptionCont').eq(0).html(function (index, html) { return html.replace(/(\|\([\d]*\)\|)/g, ""); });

                        // sumoselect is now loaded by app-formElements/main.js but the AJAX hasn't run to populate the list yet, so reload it
                        // doing this here as reloading prior to the replacements broke the functionality even though it appears fine when used elsewhere
                        $('#hostsSearchContentSelect')[0].sumo.reload();
                    }
                });
            }

            $("#specialInterestSearchButton").on("click", function () {
                //update the ADL and make the direct call
                AdlAddUpdateItem('BHsearchMethodWidgetType', 'search_panel_specialinterest');
                AdlAddUpdateItem('BHsearchMethodLinkType', 'cta');
                AdlAddUpdateItem('BHsearchMethodPagePosition', 'header');
                AdlAddUpdateItem('BHsearchMethodPageType', 'homepage');
                util.satelliteTrack('travelSearchWidget');

                var productCount = 0;

                $.ajax({
                    url: settings.resultCountUrl,
                    data: { "tags": "[" + compileSpecialInterestSearch().toString() + "]" },
                    type: "POST",
                    success: function (data) {
                        productCount = data.productCount;
                    },
                    async: false
                });

                if (productCount === 1) {
                    redirectToProductPage();
                } else {
                    var forceReload = Math.random();
                    window.location.href = '/search?' + forceReload + '#' + settings.searchUrlKey + '|[' + compileSpecialInterestSearch().toString() + ']||';
                }
            });

            function redirectToProductPage() {
                $.ajax({
                    url: settings.getResultsUrl,
                    data: { "tags": "[" + compileSpecialInterestSearch().toString() + "]" },
                    type: "POST",
                    success: function (data) {
                        window.location.href = data.paginatedResults[0].url;
                    },
                    async: false
                });
            }

            // when something changes update the search button text
            $(".siChangeTrigger").change(function () {
                $.ajax({
                    url: settings.resultCountUrl,
                    data: { 'tags': '[' + compileSpecialInterestSearch().toString() + ']' },
                    type: "POST",
                    success: function (data) {
                        var text = "See " + data.productCount + " holiday";

                        if (data.productCount > 1) {
                            text += "s";
                        }

                        $('#specialInterestSearchButton').val(text);
                    }
                });

                getSpecialInterestDepartures();

                if ($(this).hasClass('passengers')) {
                    //passengers has been changed
                    var passObj = decodeURIComponent($('#specialInterestPassengers').val());
                    var passJson = $.parseJSON(passObj);

                    AdlAddUpdateItem('editSearchPassengerNumber', passJson.value);
                    util.satelliteTrack('search results edit');
                };

                if ($(this).hasClass('dateDropdown')) {
                    //date has been changed
                    AdlAddUpdateItem('editSearchTravelDate', $('#siDateField').val());
                    util.satelliteTrack('search results edit');
                };
            });

            $('#siDateField').focus(function () {
                showDatePicker('#siDateField', compileSpecialInterestSearch().toString());

                $(this).next().slideToggle();
                $(this).blur();
            });

            getSpecialInterestDepartures();
        }
    };
});
